/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { PropertyFromJSON, } from '../models';
/**
 *
 */
var PropertiesApi = /** @class */ (function (_super) {
    __extends(PropertiesApi, _super);
    function PropertiesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     */
    PropertiesApi.prototype.getMyPropertiesRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Properties/getmyproperties",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(PropertyFromJSON); })];
                }
            });
        });
    };
    /**
     */
    PropertiesApi.prototype.getMyProperties = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMyPropertiesRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    PropertiesApi.prototype.getPropertyRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.propertyId === null || requestParameters.propertyId === undefined) {
                            throw new runtime.RequiredError('propertyId', 'Required parameter requestParameters.propertyId was null or undefined when calling getProperty.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Properties/{propertyId}".replace("{" + "propertyId" + "}", encodeURIComponent(String(requestParameters.propertyId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PropertyFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    PropertiesApi.prototype.getProperty = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPropertyRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    PropertiesApi.prototype.queryPropertiesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.fMRecordId !== undefined) {
                            queryParameters['FMRecordId'] = requestParameters.fMRecordId;
                        }
                        if (requestParameters.fMModId !== undefined) {
                            queryParameters['FMModId'] = requestParameters.fMModId;
                        }
                        if (requestParameters.propertyId !== undefined) {
                            queryParameters['PropertyId'] = requestParameters.propertyId;
                        }
                        if (requestParameters.propertyName !== undefined) {
                            queryParameters['PropertyName'] = requestParameters.propertyName;
                        }
                        if (requestParameters.address !== undefined) {
                            queryParameters['Address'] = requestParameters.address;
                        }
                        if (requestParameters.city !== undefined) {
                            queryParameters['City'] = requestParameters.city;
                        }
                        if (requestParameters.state !== undefined) {
                            queryParameters['State'] = requestParameters.state;
                        }
                        if (requestParameters.zip !== undefined) {
                            queryParameters['Zip'] = requestParameters.zip;
                        }
                        if (requestParameters.gPS !== undefined) {
                            queryParameters['GPS'] = requestParameters.gPS;
                        }
                        if (requestParameters.reqHelpName !== undefined) {
                            queryParameters['ReqHelpName'] = requestParameters.reqHelpName;
                        }
                        if (requestParameters.reqHelpPhone !== undefined) {
                            queryParameters['ReqHelpPhone'] = requestParameters.reqHelpPhone;
                        }
                        if (requestParameters.reqHelpEmail !== undefined) {
                            queryParameters['ReqHelpEmail'] = requestParameters.reqHelpEmail;
                        }
                        if (requestParameters.reqMessage !== undefined) {
                            queryParameters['ReqMessage'] = requestParameters.reqMessage;
                        }
                        if (requestParameters.reqMessageExpire !== undefined) {
                            queryParameters['ReqMessageExpire'] = requestParameters.reqMessageExpire.toISOString();
                        }
                        if (requestParameters.location1Label !== undefined) {
                            queryParameters['Location1Label'] = requestParameters.location1Label;
                        }
                        if (requestParameters.location2Label !== undefined) {
                            queryParameters['Location2Label'] = requestParameters.location2Label;
                        }
                        if (requestParameters.floorLabel !== undefined) {
                            queryParameters['FloorLabel'] = requestParameters.floorLabel;
                        }
                        if (requestParameters.propertyActiveFlag !== undefined) {
                            queryParameters['PropertyActiveFlag'] = requestParameters.propertyActiveFlag;
                        }
                        if (requestParameters.newOrdersToREQ !== undefined) {
                            queryParameters['NewOrdersToREQ'] = requestParameters.newOrdersToREQ;
                        }
                        if (requestParameters.propertyTimeZoneCode !== undefined) {
                            queryParameters['PropertyTimeZoneCode'] = requestParameters.propertyTimeZoneCode;
                        }
                        if (requestParameters.ordererFieldLabel2 !== undefined) {
                            queryParameters['OrdererFieldLabel2'] = requestParameters.ordererFieldLabel2;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Properties",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(PropertyFromJSON); })];
                }
            });
        });
    };
    /**
     */
    PropertiesApi.prototype.queryProperties = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryPropertiesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PropertiesApi;
}(runtime.BaseAPI));
export { PropertiesApi };
